import {combineReducers} from 'redux'
import {OPENING_TICKET_INSTRUCTION_STREAM_LOADED, OPENING_TICKET_INSTRUCTION_STREAM_QUERIED} from './actions'
import {CREATE_OPENING_TICKET_INSTRUCTION_ACTION_UPDATED, UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_UPDATED} from './actions'
import {CREATE_OPENING_TICKET_INSTRUCTION_ACTION_SENT, UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_SENT} from './actions'

function createOpeningTicketInstructionAction(state = null, action) {
    switch (action.type) {
        case CREATE_OPENING_TICKET_INSTRUCTION_ACTION_UPDATED:
            return {...state, ...action.action}
        case CREATE_OPENING_TICKET_INSTRUCTION_ACTION_SENT:
            return null
        default:
            return state
    }
}

function updateOpeningTicketInstructionAction(state = null, action) {
    switch (action.type) {
        case UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_UPDATED:
            return {...state, ...action.action}
        case UPDATE_OPENING_TICKET_INSTRUCTION_ACTION_SENT:
            return null
        default:
            return state
    }
}

const openingTicketInstruction = (function() {

    function stream(state = [], action) {
        switch (action.type) {
            case OPENING_TICKET_INSTRUCTION_STREAM_LOADED:
            case OPENING_TICKET_INSTRUCTION_STREAM_QUERIED:
                return action.stream
            default:
                return state
        }
    }

    function query(state = null, action) {
        switch (action.type) {
            case OPENING_TICKET_INSTRUCTION_STREAM_LOADED:
            case OPENING_TICKET_INSTRUCTION_STREAM_QUERIED:
                return action.query
            default:
                return state
        }
    }

    return combineReducers({stream, query})
})()

export default combineReducers({
	openingTicketInstruction,
    createOpeningTicketInstructionAction,
    updateOpeningTicketInstructionAction
})


// WEBPACK FOOTER //
// ./lib/message/reducers.js